import React from 'react'
import {
  EnvelopeFill,
  GeoAltFill,
  TelephoneFill,
  Clipboard,
  GeoAlt,
  Envelope,
  Telephone,

  CalendarCheck,
  BoxArrowUpRight,
} from "react-bootstrap-icons";

export default function BenContact() {

    const handleCopy = (value) => {
    navigator.clipboard.writeText(value);
  };

  const handleCall = (phone) => {
    window.location.href = `tel:${phone}`;
  };
  return (
    <section id="contact" className="py-5">
      <div className="container">

          <div className="benAboutIntro mb-4">
              <div className="benAboutEyebrowWrap">
                <span className="benAboutEyebrowLine"></span>
                <p className="benAboutEyebrow mb-0 text-uppercase">Enquiries and appointments</p>
                <span className="benAboutEyebrowLine"></span>
              </div>

              <h1 className="brand-text-dark mb-0">Contact</h1>
            </div>

   

<div className="contact-item">
  <div className="contact-icon">
    <TelephoneFill size={18} />
  </div>

  <div className="flex-grow-1">
    <p className="mb-1 fw-semibold">Phone</p>
    <p className="text-secondary mb-0">07929040880</p>
  </div>

  <div className="d-flex gap-2">
    <TelephoneFill
      size={20}
      role="button"
      onClick={() => handleCall("07929040880")}
    />
    <Clipboard
      size={20}
      role="button"
      onClick={() => handleCopy("07929040880")}
    />
  </div>
</div>

<div className="contact-item">
  <div className="contact-icon">
    <EnvelopeFill size={18} />
  </div>

  <div className="flex-grow-1">
    <p className="mb-1 fw-semibold">Email</p>
    <p className="mb-0">
      <a
        href="mailto:benjamin.piper@irise-psychology.london"
        className="text-decoration-none brand-text-light"
      >
        benjamin.piper@irise-psychology.london
      </a>
    </p>
  </div>

  <div className="d-flex gap-2">
    <Clipboard
      size={20}
      role="button"
      onClick={() =>
        handleCopy("benjamin.piper@irise-psychology.london")
      }
    />
  </div>
</div>

<div className="contact-item mb-0">
  <div className="contact-icon">
    <GeoAltFill size={18} /> 
  </div>
  <div>
    <p className="mb-1 fw-semibold">Address</p>
    <p className="text-secondary mb-0">
      The Wexner Building
      <br />
      Strype Street
      <br />
      London, E1 7LF
    </p>
  </div>
</div>

        <div className="row mt-5">
          <div className="col-12">
            <iframe
              title="The Wexner Building Map"
              src="https://www.google.com/maps?q=The%20Wexner%20Building%20Strype%20Street%20London%20E1%207LF&output=embed"
              width="100%"
              height="350"
              loading="lazy"
            ></iframe>
          </div>
        </div>

      </div>
    </section>
  )
}